
<template>
  <!--物流配送-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="id"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_logo" slot-scope="{row}">
        <img style="height: 44px;" :src="row.logoUrl" alt="">
      </template>
      <template slot="opt_type" slot-scope="{row}">
        <span>{{row.type === 1 ? '快递公司' : '同城配送'}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'logistics',
  data () {
    return {
      searchList: [
        { props: ['name'], placeholder: '公司名称', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:logistics:add'] }
      ],
      rowOptList: [
        {
          text: '编辑',
          handle: row => this.$refs.table.toEdit(row), // 处理方法
          permi: ['community:logistics:add']
        },
        {
          text: '删除',
          handle: row => this.deleteHandle(row), // 处理方法
          permi: ['community:logistics:delete']
        }
      ],
      columns: [
        { title: '公司名称', dataIndex: 'name', align: '', width: '' },
        { title: 'LOGO', dataIndex: 'logoUrl', align: '', width: '', scopedSlots: { customRender: 'logo' } },
        { title: '类型', dataIndex: 'type', align: '', width: '', scopedSlots: { customRender: 'type' } },
        { title: '排序', dataIndex: 'sort', align: '', width: '' },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],
      searchParams: {
        name: undefined
      },
      listApi: {
        url: '/pm/logisticsCompany/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addLogistics',
        addTitle: '新增物流公司',
        editTitle: '编辑物流公司'
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
  },
  methods: {
    getSelect () {
    },
    /** 删除物流公司 */
    deleteHandle (row) {
      this.$confirm({
        title: '确定要删除物流公司：' + row.name,
        centered: true,
        onOk: () => {
          this.$delete({
            url: `/pm/logisticsCompany/${row.id}`,
            params: {}
          }).then(({ data }) => {
            this.$message.success('删除成功');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
